import store from '@/store'
const TOKEN_KEY = 'okaso/token_key'
const USERNAME_SUB_KEY = 'username_sub_key'

export function useAuthFunc() {

  /**
   * 
   * @returns 
   */
  function signin(payload: {
    token: string;
    sub: string;
  }): boolean {
    // ログインOK
    localStorage.setItem(TOKEN_KEY, payload.token)
    localStorage.setItem(USERNAME_SUB_KEY, payload.sub)
    return true;
  }

  /**
   * 
   * @returns 
   */
  function signout(): boolean {
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USERNAME_SUB_KEY)
    store.dispatch('loginUser/clear')
    return true
  }

  /**
   * トークンをチェック
   * @returns 
   */
  function isValidToken(): boolean {
    const token = localStorage.getItem(TOKEN_KEY)
    return !!token;
  } 

  /**
   * 
   * @returns 
   */
  function isLoggedin(): boolean {
    return !!isValidToken();
  }

  /**
   * 
   * @returns username_sub
   */
  function getAuthSub(): string {
    return localStorage.getItem(USERNAME_SUB_KEY) || '';
  }

  return {
    signout,
    signin,
    isLoggedin,
    getAuthSub,
  };
}
